import React from 'react';
import Notfound from 'components/organisms/NotFound';

export const NotFoundLayout = lan => <Notfound lan={lan} />;
